/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT_API_TOKEN, EnvironmentApiInterface } from '@campus/environment';
import { Observable, map } from 'rxjs';
import { EduFileInterface, EduFileTypeEnum, StorageInfoInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class EduFileApi extends ModelApiBase {
  protected api: PolpoApi;

  constructor(
    api: PolpoApi,
    @Inject(ENVIRONMENT_API_TOKEN) private env: EnvironmentApiInterface
  ) {
    super(api, 'EduFiles');
  }

  find(params?): Observable<EduFileInterface[]> {
    const path = '';
    const httpParams = this._getHttpParams({ filter: params });
    return this.get<EduFileInterface[]>(path, httpParams);
  }

  uploadFile(eduContentId: number, formData: FormData): Observable<StorageInfoInterface> {
    const path = `${eduContentId}/store`;

    return this.post<{ storageInfo: StorageInfoInterface }>(path, undefined, formData).pipe(
      map(({ storageInfo }) => storageInfo)
    );
  }

  downloadFileFromMetadata(eduContentMetadataId: number, type: EduFileTypeEnum = EduFileTypeEnum.EXERCISE): string {
    return `${this.env.APIBase}/api/EduFiles/downloadFromMetadata/${eduContentMetadataId}/${type}`;
  }

  downloadEduFile(eduFileId: number): string {
    return `${this.env.APIBase}/api/EduFiles/download/${eduFileId}`;
  }

  deleteFile(eduFileId: number): Observable<boolean> {
    const path = `${eduFileId}`;
    return this.delete<number>(path, undefined).pipe(map(() => true));
  }

  redirectUrlRemote(eduFileId: number): Observable<string> {
    const path = `${eduFileId}/redirectURL`;
    return this.get<{ url: string }>(path).pipe(map((response) => response.url));
  }
}
